import styled, { css } from 'styled-components';
import { getTextTokenPreset, getToken } from '@optimus-web/core';

export const ImageWrap = styled.div`
    img {
        object-fit: cover;
        width: ${getToken('sizing500')}px;
        height: ${getToken('sizing500')}px;
        border-radius: ${getToken('borderRadius50')}px;
    }
`;

interface PropertyNameProps {
    isMobile?: boolean;
}

export const PropertyName = styled.div<PropertyNameProps>`
    ${getTextTokenPreset('bodyLarge')};
    color: ${getToken('textStaticPrimary')};

    ${(props) =>
        props.isMobile === true &&
        css`
            /* Limit the text to 2 lines */
            /* stylelint-disable-next-line value-no-vendor-prefix */
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;

            text-overflow: ellipsis;
            white-space: break-spaces;
            max-width: 150px;
            overflow: hidden;
        `};
`;
